export const getReconCaseStatus = (submittedDate, caseOpenIndicator) => {
  if (caseOpenIndicator === 'N') return CLOSED;
  else if (caseOpenIndicator === 'Y' && submittedDate) return SUBMITTED;
  return STARTED;
};

export const translateCaseStatus = status => {
  return CASE_STATUS[status] ? CASE_STATUS[status]?.displayName : 'N/A';
};

// portalCaseStatus values
export const STARTED = 'Started/Not Submitted';
export const SUBMITTED = 'Submitted';
export const CLOSED = 'Closed';

// Used for query parmams
export const CASE_DETAILS_PATH = 'case-details';
export const PAGE_SIZE = '10';

// Used for case timeline on case details page
export const CASE_STATUS = {
  [STARTED]: {
    activeStep: 0,
    displayName: 'Not Submitted'
  },
  [SUBMITTED]: {
    activeStep: 1,
    displayName: 'Under Review'
  },
  [CLOSED]: {
    activeStep: 2,
    displayName: 'Completed'
  }
};

// Used in response expander on change request tab
export const DEFAULT_RECON_MESSAGES = {
  DECISION: 'A decision will be made available after a case is submitted and reviewed.',
  CONCLUSION:
    'An investigation and conclusion will be made available after a case is submitted and reviewed.'
};

export const DESIGNATION_CHANGE = {
  Y: 'Yes',
  N: 'No'
};

export const INPATIENT_INDICATOR = 'INPATIENT';
export const OUTPATIENT_INDICATOR = 'OUTPATIENT';

